// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__RPkwJ","paramInput":"JobSimulator_paramInput__3FmXf","input":"JobSimulator_input__1AV1w"};